/* eslint-disable no-bitwise, no-fallthrough, default-case */
/**
 * JS Implementation of MurmurHash2
 * http://github.com/garycourt/murmurhash-js
 * http://sites.google.com/site/murmurhash/
 */

const murmurHash2 = (str: string, seed = 1) => {
	let l = str.length;
	let h = seed ^ l;
	let i = 0;
	let k;
	while (l >= 4) {
		k =
			(str.charCodeAt(i) & 0xff) |
			((str.charCodeAt(++i) & 0xff) << 8) |
			((str.charCodeAt(++i) & 0xff) << 16) |
			((str.charCodeAt(++i) & 0xff) << 24);
		k = (k & 0xffff) * 0x5bd1e995 + ((((k >>> 16) * 0x5bd1e995) & 0xffff) << 16);
		k ^= k >>> 24;
		k = (k & 0xffff) * 0x5bd1e995 + ((((k >>> 16) * 0x5bd1e995) & 0xffff) << 16);
		h = ((h & 0xffff) * 0x5bd1e995 + ((((h >>> 16) * 0x5bd1e995) & 0xffff) << 16)) ^ k;
		l -= 4;
		++i;
	}
	switch (l) {
		// @ts-expect-error - TS7029 - Fallthrough case in switch.
		case 3:
			h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
		// @ts-expect-error - TS7029 - Fallthrough case in switch.
		case 2:
			h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
		case 1:
			h ^= str.charCodeAt(i) & 0xff;
			h = (h & 0xffff) * 0x5bd1e995 + ((((h >>> 16) * 0x5bd1e995) & 0xffff) << 16);
	}
	h ^= h >>> 13;
	h = (h & 0xffff) * 0x5bd1e995 + ((((h >>> 16) * 0x5bd1e995) & 0xffff) << 16);
	h ^= h >>> 15;
	return h >>> 0;
};
export const cleanStack = (stack: string) => {
	const assetPaths = stack.match(/\/([\w.~\-_]+)\.[jt]sx?/g);
	const lineCols = stack.match(/:\d+:\d+/g);

	// uncomment this to get more specific paths
	// const uniquePaths = (assetPaths || [])
	//     .slice(0, 10)
	//     .reduce((acc, v) => {
	//         const [asset] = v.split(':');
	//         if (!acc.includes(asset)) acc.push(asset);
	//         return acc;
	//     }, [])
	//     .slice(1, 5);
	return (assetPaths?.[0] ?? '') + (lineCols?.[0] ?? '');
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type PartialError = Partial<Error> & Record<PropertyKey, any>;
const cache = new WeakMap<PartialError, string>();
/**
 * Creates a unique identifier for an error object, facilitating error tracking and management.
 * It first checks for the error in a cache; if not found, it generates a hash based on the error's details.
 * This process helps in recognizing similar errors efficiently, especially useful in environments
 * with stringent error handling requirements.
 */
export const getErrorHash = (error: PartialError) => {
	if (cache.has(error)) return cache.get(error);
	let stackStr = '';
	if (error.stack !== undefined) {
		try {
			stackStr = cleanStack(error.stack);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (e: any) {
			/* ignore */
		}
	}
	let errorString = `${error.name} ${stackStr || error.message}`;
	if (process.env.STORYBOOK_STRICT === 'true') {
		errorString = `${error.name} ${error.message}`;
	}
	const hash = murmurHash2(errorString).toString(36).toUpperCase();
	try {
		cache.set(error, hash);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (e: any) {
		/* ignore */
	}
	return hash;
};
